import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_disabled"}/>
}
